import Hero from "./Components/Hero";
import Nav from "./Components/Nav";
import Footer from "../about/Components/Footer";
import List from "./Components/List";

function Interviews() {
  return (
    <div>
      <Hero />
      <List />
      <Footer />
    </div>
  );
}

export default Interviews;
